<template>
  <svg
    width="36"
    height="36"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <circle
        fill="#5667C6"
        cx="18"
        cy="18"
        r="18"
      />
      <path
        d="M26 17.012l-6.267 6.645c-.222.23-.478.343-.767.343-.289 0-.544-.114-.766-.343-.49-.502-.49-1.004 0-1.506l3.933-4.042H10.067a.97.97 0 0 1-.767-.343c-.2-.228-.3-.49-.3-.788a1.04 1.04 0 0 1 1.067-1.062h12L18.2 11.944c-.49-.502-.478-1.016.033-1.541.51-.525 1.01-.537 1.5-.035L26 17.012z"
        fill="#FFF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SubmitIcon',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/SubmitIcon.vue